module.exports = __webpack_public_path__ + "static/media/loc7_img12.07c180ac.jpg";